module.exports = __webpack_public_path__ + "assets/metrics-customers.6cc8299c.svg";